import { Component, Input, ViewChild, EventEmitter, Output, HostListener } from '@angular/core';
import { BenchmarkDashboardStorageService } from '../../benchmark-dashboard.storage.service';
import { CxWindow } from '@app-frame';
import { States, StateService } from '@state';


@Component({
    selector: 'datapoint-selector-window',
    templateUrl: './datapoint-selector.template.html',
    standalone: false
})
export class DatapointSelectorComponent {

    constructor(public storage : BenchmarkDashboardStorageService, public stateService: StateService) {
        const themeConfig = this.stateService.value(States.themeConfig).get();
        this.enableUITwo = themeConfig.enableUITwo || false;
    }

    public enableUITwo = false;
    
    @ViewChild(CxWindow, { static: true })
    public window: CxWindow;


    @Input()
    public isSystemMode : boolean = false;

    @Output()
    public dropped: EventEmitter<any> = new EventEmitter()

    @HostListener('drop', ['$event'])
    public onDrop(e: any){
        this.dropped.emit(e);
    }


    @HostListener('dragover', ['$event'])
    public onDragOver(e: any){
        e.dataTransfer.dropEffect = 'move';
        return false;
    }


    public axes : any[] = [];

    private palette = ['#2882a0', '#879628', '#505a64', '#eb780a', '#9b1e5a', '#879baa', '#aaaa96'];

    public getColorByPosition(position) {
        return this.palette[position % this.palette.length];
    }

    public addDatapoint(data) {
       
        data.name = '%t %T - %N'
        const chartIndex = 0;
        const position = this.storage.data().charts[chartIndex].datapoints.length;
        data.index = position;
        data.color = this.getColorByPosition(position)
        this.storage.addDatapoint(data, chartIndex);
        this.isDatapointsSelectionOpen = false;
    }

    public chooseDatapoints() {
        this.isDatapointsSelectionOpen = true;
    }


    public datapointListChanged(data){
        if(!data?.[0]?.datapointId) {
            return;
        }
        this.storage.updateDatapointsOrder(data);
    }

    public updateDatapoint(data) {
        this.storage.updateDatapoint(data)
    }

    public deleteDatapoint(data) {
        this.storage.removeDatapoint(data)
    }

    public maxDatapoints : number = 10;

    @Input()
    public datapointIds : any[] = [];


    public isDatapointsSelectionOpen : boolean = false;

    public ngAfterViewInit() {
       // this
    }
}